import BreakingNews from "../../components/BreakingNews";
import NewsCard from "../../components/NewsCard";
import WebStories from "../../components/WebStories.jsx";
import Profilecard from "../../components/Profilecard";
import EducationDetailData from "../../pages/Education/Educationdata.js";

import { latestStories } from "../home/sidebarData";
import AdBanner from "../../components/AdBanner";
import {
  topNews2,
  topNews,
  mpNews,
  videonews,
  webStories
} from "../home/homeData";

const Education = () => {
  return (
    <div className="max-w-7xl mx-auto -mt-[65px] px-4 py-6 sm:mt-[0px]">
      <BreakingNews />
<div className="mt-2 grid grid-cols-1 lg:grid-cols-12 gap-6">

        {/* ================= LEFT SIDE ================= */}
        <div className="lg:col-span-9 space-y-12">

          {/* 🔹 TOP NEWS */}
                 <section>
                      <div className="lg:col-span-9">
                          <Profilecard data={EducationDetailData} />
                      </div>
                 </section>
                   <section>
                      <div className="lg:col-span-9">
                          <Profilecard data={EducationDetailData} />
                      </div>
                 </section>
                   <section>
                      <div className="lg:col-span-9">
                          <Profilecard data={EducationDetailData} />
                      </div>
                 </section>
                   <section>
                      <div className="lg:col-span-9">
                          <Profilecard data={EducationDetailData} />
                      </div>
                 </section>
                 <section>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {mpNews.slice(0, 2).map((item, i) => (
                <NewsCard key={i} {...item} />
              ))}
            </div>
          </section>

          <section>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {mpNews.slice(0, 3).map((item, i) => (
                <NewsCard key={i} {...item} />
              ))}
            </div>
          </section>
               

        

        </div>

        {/* ================= RIGHT SIDE ================= */}
        <aside className="lg:col-span-3">
          <div className="sticky top-[120px]">

            <div className="bg-rich-black border-zinc-800 rounded-lg border shadow-sm overflow-hidden">

              {/* HEADER */}
              <div className="px-4 py-3 border-b">
                <h3 className="font-bold text-purple-600 text-[18px] uppercase tracking-wide">
                  Latest Stories
                </h3>
              </div>

              {/* STORIES */}
              <div>
                {latestStories.map((item) => (
                  <a
                    key={item.id}
                    href={item.link}
                    className="flex gap-3 p-2 hover:bg-gray-50 transition group"
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-20 h-14 object-cover rounded"
                    />

                    <p className="text-sm text-gray-200 font-medium leading-snug line-clamp-2 group-hover:text-brand-red">
                      {item.title}
                    </p>
                  </a>
                ))}
              </div>

              {/* 🔹 ADVERTISEMENT (DATA-DRIVEN + CLICKABLE) */}
              <AdBanner />


            </div>

          </div>
        </aside>

      </div>
    </div>
  );
};

export default Education;
